import { graphql, rest } from 'services/api';
import * as queries from './queries';
import * as mutations from './mutations';
import { AtsList, IntegrationCredentials, RejectedReason } from './types';
import { KomboJobsResponse } from './types/komboJob';

export const retrieveConnectSessionToken = async () => {
  const response = await rest.post('/integration/fetch-session-token', {});

  return {
    token: response.connectSessionTokenAuthLink.token
  };
};

export const createKomboConnectionLink = async (): Promise<{
  link: string;
}> => {
  return await rest.post('/integration/create-kombo-connection-link', {});
};

export const getIntegrationCredentialsByOrganization = async ({
  organizationId
}: {
  organizationId: string;
}) => {
  const response = await graphql.query(
    queries.getIntegrationCredentialsByOrganization,
    {
      organizationId
    }
  );

  return response.getIntegrationCredentialsByOrganization.items[0];
};

export const getKomboJobs = async (params: {
  pageSize?: number;
  next?: string | null;
  nameContains?: string;
  remoteIds?: string;
  jobCodes?: string;
  statuses?: string;
  isForAnalysis?: boolean;
}): Promise<KomboJobsResponse> => {
  const query: Record<string, string> = {};
  if (params.pageSize != null) query.pageSize = String(params.pageSize);
  if (params.next) query.next = params.next;
  if (params.nameContains) query.nameContains = params.nameContains;
  if (params.remoteIds) query.remoteIds = params.remoteIds;
  if (params.jobCodes) query.jobCodes = params.jobCodes;
  if (params.statuses) query.statuses = params.statuses;
  if (params.isForAnalysis) query.isForAnalysis = 'true';

  return rest.get('/integration/fetch-kombo-jobs', query);
};

export const getRejectedReasons = (): Promise<RejectedReason[]> =>
  rest.get('/integration/fetch-rejected-reasons');

export const getInterviewStages = async ({
  atsJobId
}: {
  atsJobId?: string | null;
}) => {
  return rest.get('/integration/fetch-interview-stages', {
    ...((atsJobId && { atsJobId }) || {})
  });
};

export const getAtsLists = (): Promise<{
  data: AtsList[];
  next: string | null;
}> => rest.get('/integration/fetch-lists');

export const updateAtsIntegrationActiveState = async ({
  id,
  isActive
}: {
  id: string;
  isActive: boolean;
}): Promise<IntegrationCredentials> => {
  const response = await graphql.mutation(
    mutations.updateIntegrationCredentials,
    {
      id,
      isActive
    }
  );

  return response.updateIntegrationCredentials;
};

export const generatePortalUrl = async ({
  candidateBatchId,
  campaignId
}: {
  candidateBatchId?: string;
  campaignId?: string;
}) =>
  rest.post('/integration/generate-typeform-url', {
    candidateBatchId,
    campaignId
  });
